export default theme => ({
  pad: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '14px 18px',
    borderTop: '1px solid #3a3f47',
    backgroundColor: '#1c1f24',
  },
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '12px',
  },
  modeBar: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '10px',
    marginLeft: 'auto',
  },
  label: {
    width: 48,
    marginRight: 4,
    fontSize: 11,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    color: '#9aa3ad',
  },
  dirGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 36px)',
    gap: '4px',
    marginRight: 6,
  },
  dirButton: {
    minWidth: 0,
    width: 36,
    height: 36,
    padding: 0,
    color: '#c8ccd4',
    borderColor: '#3a3f47',
  },
  dirButtonActive: {
    backgroundColor: '#ecece8',
    color: '#101318',
  },
  textButton: {
    minWidth: 0,
    height: 36,
    padding: '6px 14px',
    whiteSpace: 'nowrap',
    color: '#c8ccd4',
    borderColor: '#3a3f47',
  },
  input: {
    width: 72,
    marginRight: 4,
    '& input': {
      color: '#ecece8',
      fontFamily: 'IBM Plex Mono, monospace',
      padding: '8px 10px',
      backgroundColor: '#12151a',
      border: '1px solid #3a3f47',
      borderRadius: 4,
    },
  },
  unit: {
    marginRight: 8,
    color: '#9aa3ad',
    fontSize: 13,
  },
  primaryButton: {
    backgroundColor: '#ecece8',
    color: '#101318',
    '&:hover': {
      backgroundColor: '#d8d4c8',
    },
    '&$disabled': {
      opacity: 0.4,
    },
  },
  disabled: {},
});
